import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	and: {
		id: 'jql-builder-basic-datetime.between-date-time.and',
		defaultMessage: 'and',
		description: 'Conjunction connecting start and end dates in a date interval',
	},
	startDateLabel: {
		id: 'jql-builder-basic-datetime.between-date-time.start-date-label',
		defaultMessage: 'Choose a start date',
		description: 'Label for the start date',
	},
	endDateLabel: {
		id: 'jql-builder-basic-datetime.between-date-time.end-date-label',
		defaultMessage: 'Choose an end date',
		description: 'Label for the end date',
	},
	startTimeLabel: {
		id: 'jql-builder-basic-datetime.between-date-time.start-time-label',
		defaultMessage: 'Choose a start time',
		description: 'Label for the start time',
	},
	endTimeLabel: {
		id: 'jql-builder-basic-datetime.between-date-time.end-time-label',
		defaultMessage: 'Choose an end time',
		description: 'Label for the end ime',
	},
});
